import useDataEvents from '../../../../dataHooks/useDataEvents';

export default () => {
  const { fetchShareLogistics } = useDataEvents()

  const getKey = async (eventData) => {
    const { key } = await fetchShareLogistics({ eventId: eventData.id })
    const encodedKey = encodeURIComponent(key)
    return encodedKey
  }

  const getShareEventLink = (eventData) => {
    const { projectIdNumber } = eventData
    return `${window.location.host}/share/M${projectIdNumber}`
  }

  const getShareEventLinkData = async (eventData, isIncludeKey) => {
    const url = getShareEventLink(eventData)
    const query = (isIncludeKey ? `?key=${await getKey(eventData)}` : '')
    return {
      url: `${url}${query}`,
      rootUrl: `${url}`
    }
  }

  const getShareLogisticsLinkData = async (eventData, isIncludeKey) => {
    const { projectIdNumber } = eventData
    const query = (isIncludeKey ? `?key=${await getKey(eventData)}` : '')
    //return `${urlSubdomain}events.${env ? `${env}.` : ''}prosolve.com/logistics/M${projectIdNumber}${query}`
    return {
      url: `${window.location.host}/logistics/M${projectIdNumber}${query}`,
      rootUrl: `${window.location.host}/logistics/M${projectIdNumber}`
    }
  }

  return {
    getShareEventLink,
    getShareEventLinkData,
    getShareLogisticsLinkData,
  }
}